import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics/constants';
import { Avatar, AvatarFallback } from 'components/avatar/avatar';
import { AmbossIcon } from 'widgets/amboss/AmbossIcon';

export const TitleBarNav = styled.nav.attrs<{ $dark: boolean }>(({ $dark }) => ({
  className: `fixed top-0 left-0 right-0 z-50 flex h-14 items-center gap-2 px-3 py-1 shadow-[0_1px_0_0_rgba(0,0,0,0.05)] ${
    $dark ? 'bg-primary text-primary-foreground' : 'bg-card text-foreground'
  }`,
}))<{ $dark: boolean }>``;

export const LeadingArea = styled.div.attrs({
  className: 'flex flex-1 items-center gap-2 min-w-0',
})``;

export const BackButton = styled.button.attrs({
  className:
    'flex h-8 w-8 shrink-0 items-center justify-center rounded-md transition-colors cursor-pointer hover:opacity-80',
})``;

export const LogoSlot = styled.div.attrs<{ $wide: boolean }>(({ $wide }) => ({
  className: `flex h-8 shrink-0 items-center justify-center ${$wide ? 'px-1' : 'w-8'}`,
}))<{ $wide: boolean }>``;

export const LogoImage = styled.img.attrs({
  className: 'h-6 w-auto cursor-pointer',
})``;

export const TitleArea = styled.div.attrs({
  className: 'flex flex-1 items-center justify-start min-w-0 overflow-hidden',
})``;

export const TitleStack = styled.div.attrs({
  className: 'flex flex-col min-w-0',
})``;

export const Title = styled.p.attrs({
  className: `truncate text-base font-semibold leading-6 ${MASKED_TEXT_CLASS}`,
})``;

export const Subtitle = styled.p.attrs({
  className: `truncate text-xs text-muted-foreground leading-4 ${MASKED_TEXT_CLASS}`,
})``;

export const ActionsArea = styled.div.attrs({
  className: 'flex shrink-0 items-center gap-2',
})``;

export const AmbossButton = styled.button.attrs<{ $active: boolean }>(({ $active }) => ({
  type: 'button',
  className: `flex h-8 w-8 items-center justify-center rounded-md transition-colors cursor-pointer ${
    $active ? 'bg-amboss-active' : 'hover:bg-muted/80'
  }`,
}))<{ $active: boolean }>``;

export const TitleBarAmbossIcon = styled(AmbossIcon).attrs<{ $active: boolean }>(({ $active }) => ({
  className: $active ? 'text-amboss-active-foreground' : undefined,
}))<{ $active: boolean }>``;

export const PreLoginMenuButton = styled.button.attrs({
  type: 'button',
  className:
    'flex h-8 w-8 items-center justify-center rounded-md transition-colors cursor-pointer hover:bg-muted/80',
})``;

export const UserAvatar = styled(Avatar).attrs({
  className: 'h-8 w-8 cursor-pointer rounded-[6px]',
})``;

export const UserAvatarFallback = styled(AvatarFallback).attrs<{ $dark: boolean }>(({ $dark }) => ({
  className: `rounded-[6px] text-sm ${$dark ? 'bg-primary text-white' : 'bg-muted text-primary'}`,
}))<{ $dark: boolean }>``;
